export default "__VITE_ASSET__LHqUl$GF__"